import { render, staticRenderFns } from "./pagination-dropdown.vue?vue&type=template&id=b1cdf544&"
import script from "./pagination-dropdown.vue?vue&type=script&lang=js&"
export * from "./pagination-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b1cdf544', component.options)
    } else {
      api.reload('b1cdf544', component.options)
    }
    module.hot.accept("./pagination-dropdown.vue?vue&type=template&id=b1cdf544&", function () {
      api.rerender('b1cdf544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/listing/pagination-dropdown.vue"
export default component.exports